<template>
    <calculation-container>
        <calculation-project-list v-if="projects.length"/>
    </calculation-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CalculationContainer from '../../CalculationContainer';
import CalculationProjectList from './ProjectList';
import CalculationMixin from '../mixins/calculation.mixin';

export default {
    mixins:     [CalculationMixin],
    name:       'CalculationProjectSelectContainer',
    components: {
        CalculationProjectList,
        CalculationContainer
    },
    mounted() {
        this.fetchProjects();
        this.remarketingDataLayer();
    },
    beforeMount() {
        this.showTopSection();
        this.showBottomSection();
    },
    computed:   {
        ...mapGetters('calculation', ['projects'])
    },
    methods:    {
        ...mapActions('calculation', ['fetchProjects']),
        showTopSection() {
            const calculationInfoContainer = document.getElementById('calculation-info-container');
            if (calculationInfoContainer) {
                calculationInfoContainer.style.display = 'block';
            }
        },
        showBottomSection() {
            const calculationInfoContainer = document.getElementById('calculation-bottom-container');
            if (calculationInfoContainer) {
                calculationInfoContainer.style.display = 'block';
            }
        },
        remarketingDataLayer() {
            dataLayer.push({
                'event':     'calculator_step_0',
                'step':      0,
                'ecommerce': {
                    'checkout': {
                        'actionField': { 'step': 0 }
                    }
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/calculation/calculator/project/ProjectSelectContainer.vue